import { UserAdapter as CoreUserAdapter } from '@core/adapters';

export class UserAdapter extends CoreUserAdapter {
  // override methods
}
